<template>
  <div>
    <v-treeview
      v-model="selected"
      :items="formatted"
      selection-type="leaf"
      selectable
      dense
      return-object
      ref="tree"
      selected-color="primary"
      @input="$emit('input', selected)"
    ></v-treeview>
  </div>
</template>

<script>
import { prettyNames } from '@/mixins/prettyNames.js'
export default {
  data () {
    return {
      selected: [],
      initial: []
    }
  },
  mixins: [prettyNames],
  methods: {
    getRecursiveArrays: function (obj) {
      var items = []
      Object.entries(obj).forEach(element => {
        if (element[1] && typeof element[1] === 'object') {
          items.push({
            id: Math.random().toString() + element[0],
            name: this.prettyNames && this.prettyNames[element[0]] ? this.prettyNames[element[0]] : element[0],
            children: this.getRecursiveArrays(element[1])
          })
        } else if (element[1] && typeof element[1] === 'string') {
          items.push({
            id: element[1],
            name: this.prettyNames && this.prettyNames[element[this.leafName]] ? this.prettyNames[element[this.leafName]] : element[this.leafName]
          })
          this.initial.push({
            id: element[1],
            name: this.prettyNames && this.prettyNames[element[this.leafName]] ? this.prettyNames[element[this.leafName]] : element[this.leafName]
          })
        } else {
          console.log('error')
        }
      })
      return items.sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  computed: {
    formatted: function () {
      return this.getRecursiveArrays(this.data)
    }
  },
  mounted: function () {
    if (!this.base) {
      this.selected = this.initial
    } else {
      this.selected = this.base
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    leafName: {
      type: Number,
      required: true
    },
    value: {},
    base: {
      type: Array,
      required: false
    },
    prettyNames: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  }
}
</script>
